import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'nts-spinner',
    templateUrl: './spinner.component.html',
    styleUrls: ['./spinner.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: []
})
export class SpinnerComponent {

    @Input() isVisible = false;

    constructor() {
    }
}
